import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Button, message } from "antd"
import { listBatchesV4, markMex } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'

function MexPage() {
    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [showBtnMex, setShowBtnMex] = useState(false)
    const [errorInput, setErrorInput] = useState('')
    const [batchesId, setBatchesId] = useState('')

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setShowBtnMex(false)

        const checkValue = /^\w+-\d/.test(valueInput)
        if (!checkValue || !valueInput.trim()) {
            setErrorInput('Mã lô sai định dạng.')
            setLoading(false)
        }

        if (checkValue && valueInput.trim()) {
            try {
                const { data } = await listBatchesV4({ name: valueInput })
                const { data: res } = Object.assign({}, data)
                const { batches } = res

                if (!batches.length > 0) return Modal.error({
                    title: 'Lỗi',
                    content: 'Không tìm thấy tên lô',
                    onOk: _resetScanInput(),
                    okText: 'Đóng'
                })

                const { _id, status, name } = Object.assign({}, ...batches)
                setBatchesId(_id)

                if (!['wait_to_sew', 'sewing'].includes(status)) return message.error(`Lô ${name} đang ở trạng thái ${status}, không thể ép mex.`)

                return setShowBtnMex(true)

            } catch (error) {
                setErrorInput(error)
            } finally {
                setLoading(false)
            }
        }
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
        setShowBtnMex(false)
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
        setShowBtnMex(false)
    }

    const handleMex = async (e) => {
        e.preventDefault()
        setLoading(true)
        setErrorInput('')

        try {
            const { data: response } = await markMex(batchesId)
            const { error, success } = Object.assign({}, response)

            if (!success) return message.error(error)

            message.success('Xác nhận ép mex thành công!')
            _resetScanInput()

        } catch (error) {
            message.error(error)
        } finally {
            setLoading(false)
        }

    }


    return (
        <div className='MexPage py-5'>
            <div className="col-12 mx-auto px-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1 className="PageTitle">Đánh dấu ép mex</h1>
                    <label className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6">
                        <NavLink exact to='/list-mex' className='nav-link p-0'>
                            Danh sách ép mex
                        </NavLink>
                    </label>
                </div>
                <div className="site-layout-background pb-4">
                    <div className="UpdateLazeCutting">
                        <div className="UpdateLazeCuttingPage">
                            <div className="position-relative">
                                <Spin spinning={loading} tip='Đang kiểm tra...'>
                                    <form onSubmit={_onSubmit} className="formQC">
                                        <Input
                                            value={valueInput.toUpperCase()}
                                            style={{ fontSize: 40, height: "auto" }}
                                            ref={_input}
                                            autoFocus={true}
                                            placeholder='Nhập vào tên lô'
                                            onChange={_handleChangeScan}
                                        />

                                        {
                                            valueInput &&
                                            <Icon
                                                type='close-circle'
                                                className="position-absolute cursor-pointer text-dark IconInput"
                                                onClick={_resetScanInput}
                                            />
                                        }

                                        {
                                            loading &&
                                            <Icon type="sync" spin className="position-absolute IconInput" />
                                        }

                                        {
                                            (!loading) && showBtnMex &&
                                            <Button
                                                type='primary'
                                                className='float-right mt-3 px-4'
                                                onClick={handleMex}
                                            >
                                               Xác nhận ép mex
                                            </Button>
                                        }
                                    </form>

                                    {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MexPage